import { Card, Title, Text, Badge } from '@tremor/react';
import type { CustomerHeader as CustomerHeaderData } from '../api/types';
import { t } from '../lib/i18n';

const mxn = (n: number) =>
  n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });

const badgeColor = { active: 'green', suspended: 'red', over_limit: 'amber' } as const;

export default function CustomerHeader({ header }: { header: CustomerHeaderData }) {
  const addr = [header.addr1, header.addr2, header.city, header.state, header.zip]
    .filter(Boolean).join(', ');
  return (
    <Card>
      <div className="flex items-start justify-between gap-4">
        <div>
          <Title>{header.name}</Title>
          {header.name2 && <Text>{header.name2}</Text>}
          <div className="mt-2 grid grid-cols-2 gap-x-6 gap-y-1 text-sm">
            <div><b>{t.customer.header.anum}:</b> {header.anum}</div>
            {header.phone && <div><b>{t.customer.header.phone}:</b> {header.phone}</div>}
            {header.tax_id && <div><b>{t.customer.header.taxId}:</b> {header.tax_id}</div>}
            {addr && <div className="col-span-2"><b>{t.customer.header.address}:</b> {addr}</div>}
            <div><b>{t.customer.header.creditLimit}:</b> {mxn(header.credit_limit_mxn)}</div>
          </div>
        </div>
        <Badge color={badgeColor[header.status]}>
          {t.customer.header.status[header.status]}
        </Badge>
      </div>
    </Card>
  );
}
